export const PLATFORM_PREFIXES = [
  '/dashboard',
  '/workspace',
  '/sub-account',
  '/admin',
  '/ai-employees',
  '/onboarding',
  '/billing-setup',
];

export const isPlatformPath = (pathname) =>
  PLATFORM_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'));
